import { TbChevronDown } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const ChevronDownIcon = (props: IconProps) => {
  return <IconBase icon={TbChevronDown} {...props} />;
};
